/// <amd-module name="Analytics/Shared/Common/Utils/TrendCalculator" />
import { TrendType } from "Analytics/Shared/Common/Types";
import { ITrendData } from "Analytics/Shared/Common/Types";
import { getPercentageVariation } from "Analytics/Shared/Utils/Number";

export function getTrendFromData(startValue: number, endValue: number, calculatePercentage: boolean): ITrendData | undefined {
    let trend = undefined;
    if (startValue != endValue) {
        let trendType = TrendType.Increased;
        if (startValue > endValue) {
            trendType = TrendType.Decreased;
        }
        let percentageVariation = calculatePercentage
            ? Math.abs(getPercentageVariation(startValue, endValue))
            : Math.abs(Math.round((endValue - startValue) * 100) / 100);
        percentageVariation = Math.round(percentageVariation * 1e1) / 1e1;
        trend = {
            startValue: startValue,
            endValue: endValue,
            percentageVariation: percentageVariation,
            trendType: trendType
        };
    }
    return trend;
}
